module.exports = __webpack_public_path__ + "static/media/bars-solid.b3f49afd.svg";